import { Badge } from "@/components/ui/badge";

const badges = [
  "GPS Tracked", "AI Powered", "Industry Leading",
  "Industry Compliant", "Works on Any Smartphone", "Cloud Based",
];

const cards = [
  { 
    title: "Our Mission", 
    text: "To empower security companies worldwide with professional security patrol management technology. We eliminate guesswork, prevent guard fraud through biometric verification, and ensure every critical checkpoint is accounted for with real-time GPS tracking." 
  },
  { 
    title: "Our Vision", 
    text: "Creating a global standard for security accountability. We envision a future where site operators and business owners have absolute peace of mind, knowing their assets are protected by verified, transparent, and data-driven patrol operations." 
  },
  { 
    title: "Our Promise", 
    text: "High-performance security software with no specialized hardware required. We provide full operational transparency, sub-meter GPS accuracy, and AI-powered incident reporting that delivers actionable intelligence from day one." 
  },
];

const AboutSection = () => (
  <section id="about" className="py-24">
    <div className="mx-auto max-w-7xl px-6">
      <p className="text-sm font-semibold tracking-widest text-primary">About SecureFlex</p>
      <h2 className="mt-2 text-3xl font-bold md:text-5xl">BUILT FOR SECURITY PROFESSIONALS</h2>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {cards.map((c, i) => (
          <div key={c.title} className="rounded-xl border border-border bg-card p-8 animate-fade-in" style={{ animationDelay: `${i * 0.15}s`, animationFillMode: "backwards" }}>
            <h3 className="mb-3 text-xl font-bold">{c.title}</h3>
            <p className="text-muted-foreground">{c.text}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 flex flex-wrap gap-3">
        {badges.map((b) => (
          <Badge key={b} variant="secondary" className="rounded-full px-4 py-1.5 text-sm">{b}</Badge>
        ))}
      </div>
    </div>
  </section>
);

export default AboutSection;
